"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NEXT = exports.PREV = exports.UNAVAILABLE = exports.AVAILABLE = exports.LOADING = exports.EXISTING = exports.NEW = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _reactComponents = require("@cimpress/react-components");

var _emotion = require("emotion");

var _moment = _interopRequireDefault(require("moment"));

var _get = _interopRequireDefault(require("lodash/get"));

var _reactIntl = require("react-intl");

var _ListPriceInitiatorMerchantSelectStep = _interopRequireDefault(require("./ListPriceInitiatorMerchantSelectStep"));

var _ListPriceInitiatorConfirmStep = _interopRequireDefault(require("./ListPriceInitiatorConfirmStep"));

var _ListPriceCreateStep = _interopRequireDefault(require("./ListPriceCreateStep"));

var _services = require("./services");

var _constants = require("./constants");

var _logger = require("../logger");

var _ListPriceInitiatorCreateOptionStep = _interopRequireDefault(require("./ListPriceInitiatorCreateOptionStep"));

var _listPriceInitiatorMessages = require("./listPriceInitiatorMessages");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  float: left;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var NEW = 'new';
exports.NEW = NEW;
var EXISTING = 'existing';
exports.EXISTING = EXISTING;
var LOADING = 'loading';
exports.LOADING = LOADING;
var AVAILABLE = 'available';
exports.AVAILABLE = AVAILABLE;
var UNAVAILABLE = 'unavailable';
exports.UNAVAILABLE = UNAVAILABLE;
var PREV = 'prev';
exports.PREV = PREV;
var NEXT = 'next';
exports.NEXT = NEXT;
var CHOOSE_MERCHANT_STEP = 0;
var CREATE_OPTION_STEP = 1;
var CREATE_STEP = 2;
var defaultState = {
  contractCreated: false,
  contractCreating: false,
  newContractName: '',
  createOption: null,
  contractSkuDetails: null,
  duplicateSkuDetails: null,
  errorInfo: null,
  hasError: false,
  lastAction: null,
  listPrices: null,
  listPriceContractsStatus: UNAVAILABLE,
  skuDetailsStatus: UNAVAILABLE,
  merchantId: '',
  merchantName: '',
  newlyCreatedTermId: null,
  newlyCreatedTermRevisionId: null,
  noEndDateChecked: true,
  selectedListPriceContract: null,
  selectedEndDate: null,
  selectedStartDate: (0, _moment.default)(),
  skuDescriptions: null,
  skusOnContract: [],
  step: 0
};
var backButtonStyle = (0, _emotion.css)(_templateObject());

var ListPriceInitiatorWizardModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListPriceInitiatorWizardModal, _React$Component);

  function ListPriceInitiatorWizardModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ListPriceInitiatorWizardModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListPriceInitiatorWizardModal).call(this, props));

    _this.createPatchRequest = function (skuList) {
      var value = skuList.map(function (sku) {
        return {
          sku: sku
        };
      });
      var path = '/items';
      var op = 'add';
      return [{
        value: value,
        path: path,
        op: op
      }];
    };

    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = (0, _objectSpread2.default)({}, defaultState);
    _this.componentName = 'ListPriceInitiatorWizardModal';
    _this.logger = (0, _logger.getLoggerForToken)(props.onGetAccessToken);
    return _this;
  }

  (0, _createClass2.default)(ListPriceInitiatorWizardModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var updatedWhenOnlyHaveOneMerchant = !prevState.merchantId && !this.hasManyAllowedMerchants() && this.props.allowedMerchants.length === 1;

      if (prevProps.show && !this.props.show) {
        this.setState((0, _objectSpread2.default)({}, defaultState));
      }

      if (updatedWhenOnlyHaveOneMerchant) {
        this.setState({
          merchantId: this.props.allowedMerchants[0].value,
          merchantName: this.props.allowedMerchants[0].label,
          step: 1
        });
      }
    }
  }, {
    key: "onMerchantIdChange",
    value: function onMerchantIdChange(selectedObj) {
      var merchantId = this.state.merchantId;
      var newMerchantId = selectedObj ? selectedObj.value : null;
      var newMerchantName = selectedObj ? selectedObj.label : null;

      if (merchantId !== newMerchantId) {
        this.setState((0, _objectSpread2.default)({}, defaultState, {
          merchantId: newMerchantId,
          merchantName: newMerchantName
        }));
      }
    }
  }, {
    key: "onChangeNewContractName",
    value: function onChangeNewContractName(newContractName) {
      this.setState({
        newContractName: newContractName
      });
    }
  }, {
    key: "onSelectedCreateOption",
    value: function onSelectedCreateOption(createOption) {
      this.setState({
        createOption: createOption
      });
    }
  }, {
    key: "onSelectListPriceContract",
    value: function onSelectListPriceContract(selectedListPriceContract) {
      this.setState({
        selectedListPriceContract: selectedListPriceContract
      });
    }
  }, {
    key: "setContractSkuDetails",
    value: function setContractSkuDetails(contractSkuDetails) {
      this.setState({
        contractSkuDetails: contractSkuDetails
      });
    }
  }, {
    key: "setDuplicateSkuDetails",
    value: function setDuplicateSkuDetails(duplicateSkuDetails) {
      this.setState({
        duplicateSkuDetails: duplicateSkuDetails
      });
    }
  }, {
    key: "setAvailableListPriceContracts",
    value: function setAvailableListPriceContracts(listPrices) {
      var createOption = this.state.createOption;
      var step = listPrices.length !== 0 ? this.state.step : this.state.step + 1;
      createOption = listPrices.length !== 0 ? EXISTING : NEW;
      this.setState({
        createOption: createOption,
        listPrices: listPrices,
        listPriceContractsStatus: AVAILABLE,
        step: step
      });
    }
  }, {
    key: "setListPriceContractsStatus",
    value: function setListPriceContractsStatus(listPriceContractsStatus) {
      this.setState({
        listPriceContractsStatus: listPriceContractsStatus
      });
    }
  }, {
    key: "setError",
    value: function setError(err) {
      this.setState({
        hasError: true,
        errorInfo: err
      });
    }
  }, {
    key: "setSkuDetailsStatus",
    value: function setSkuDetailsStatus(skuDetailsStatus) {
      this.setState({
        skuDetailsStatus: skuDetailsStatus
      });
    }
  }, {
    key: "getEndDate",
    value: function getEndDate() {
      var _this$state = this.state,
          createOption = _this$state.createOption,
          noEndDateChecked = _this$state.noEndDateChecked,
          selectedEndDate = _this$state.selectedEndDate,
          selectedListPriceContract = _this$state.selectedListPriceContract;
      var newOptionEndDate = noEndDateChecked ? null : (0, _moment.default)(selectedEndDate);
      return createOption === NEW ? newOptionEndDate : (0, _moment.default)(selectedListPriceContract.effectiveEndDate, 'YYYY-MM-DD');
    }
  }, {
    key: "getStartDate",
    value: function getStartDate() {
      var _this$state2 = this.state,
          createOption = _this$state2.createOption,
          selectedStartDate = _this$state2.selectedStartDate,
          selectedListPriceContract = _this$state2.selectedListPriceContract;
      return createOption === NEW ? (0, _moment.default)(selectedStartDate) : (0, _moment.default)(selectedListPriceContract.effectiveStartDate, 'YYYY-MM-DD');
    }
  }, {
    key: "getModifiers",
    value: function getModifiers() {
      var _this$state3 = this.state,
          createOption = _this$state3.createOption,
          selectedListPriceContract = _this$state3.selectedListPriceContract;
      return createOption === EXISTING ? selectedListPriceContract && selectedListPriceContract.modifiers : null;
    }
  }, {
    key: "getContractName",
    value: function getContractName() {
      var _this$state4 = this.state,
          createOption = _this$state4.createOption,
          newContractName = _this$state4.newContractName,
          selectedListPriceContract = _this$state4.selectedListPriceContract;
      return createOption === NEW ? newContractName : selectedListPriceContract.additionalData.name;
    }
  }, {
    key: "handleError",
    value: function handleError(errorMsg) {
      this.logger.error(errorMsg, this.componentName);
      this.setError(errorMsg);
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState((0, _objectSpread2.default)({}, this.defaultState));
      this.props.onClose();
    }
  }, {
    key: "prevStep",
    value: function prevStep() {
      this.setState({
        lastAction: PREV,
        step: this.state.step - 1
      });
    }
  }, {
    key: "nextStep",
    value: function nextStep() {
      this.setState({
        lastAction: NEXT,
        step: this.state.step + 1
      });
    }
  }, {
    key: "hasManyAllowedMerchants",
    value: function hasManyAllowedMerchants() {
      var allowedMerchants = this.props.allowedMerchants;
      return allowedMerchants && allowedMerchants.length > 1;
    }
  }, {
    key: "addSkusToContract",
    value: function addSkusToContract() {
      var createOption = this.state.createOption;

      if (createOption === NEW) {
        this.createListPriceContract();
      } else {
        this.patchExistingListPriceContract();
      }
    }
  }, {
    key: "patchExistingListPriceContract",
    value: function () {
      var _patchExistingListPriceContract = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _this2 = this;

        var _this$props, contractCreationCallback, isProduction, onGetAccessToken, formatMessage, _this$state5, selectedListPriceContract, contractSkuDetails, contractSkus, termId, revisionId, contractItems, skusToAdd, skus;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, contractCreationCallback = _this$props.contractCreationCallback, isProduction = _this$props.isProduction, onGetAccessToken = _this$props.onGetAccessToken, formatMessage = _this$props.intl.formatMessage;
                _this$state5 = this.state, selectedListPriceContract = _this$state5.selectedListPriceContract, contractSkuDetails = _this$state5.contractSkuDetails;
                contractSkus = [];

                if (!selectedListPriceContract) {
                  _context.next = 9;
                  break;
                }

                termId = selectedListPriceContract.termId, revisionId = selectedListPriceContract.revisionId;
                _context.next = 7;
                return (0, _services.getContractItems)(termId, revisionId, isProduction, onGetAccessToken);

              case 7:
                contractItems = _context.sent;
                contractSkus = contractItems.map(function (item) {
                  return item.sku;
                });

              case 9:
                skusToAdd = Object.keys(contractSkuDetails);
                skus = Array.from(new Set([].concat((0, _toConsumableArray2.default)(skusToAdd), (0, _toConsumableArray2.default)(contractSkus))));
                this.setState({
                  contractCreating: true
                });
                (0, _services.patchRevision)(selectedListPriceContract.termId, selectedListPriceContract.revisionId, skus, onGetAccessToken, isProduction).then(function (res) {
                  contractCreationCallback({
                    contract: res,
                    allSkus: skus,
                    skusAddedToContract: skus,
                    status: 'CREATED'
                  });

                  _this2.setState({
                    contractCreating: false,
                    contractCreated: true,
                    newlyCreatedTermId: res.termId,
                    newlyCreatedTermRevisionId: res.revisionId
                  });
                }).catch(function (e) {
                  _this2.setState({
                    contractCreating: false,
                    contractCreated: false
                  });

                  contractCreationCallback({
                    allSkus: skus,
                    skusAddedToContract: [],
                    status: 'ERROR',
                    error: e
                  });
                  var validationError = (0, _get.default)(e, 'response.extensions.innerDetails.validationErrors[0]');
                  var errorMsg = validationError ? "".concat(validationError.message, " ").concat(validationError.value) : formatMessage(_listPriceInitiatorMessages.generalModalMessages.defaultErrorCreationMessage);

                  _this2.handleError(errorMsg);
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function patchExistingListPriceContract() {
        return _patchExistingListPriceContract.apply(this, arguments);
      }

      return patchExistingListPriceContract;
    }()
  }, {
    key: "createListPriceContract",
    value: function createListPriceContract() {
      var _this3 = this;

      var _this$props2 = this.props,
          contractCreationCallback = _this$props2.contractCreationCallback,
          productFulfiller = _this$props2.productFulfiller,
          skuFamily = _this$props2.skuFamily,
          onGetAccessToken = _this$props2.onGetAccessToken,
          isProduction = _this$props2.isProduction,
          formatMessage = _this$props2.intl.formatMessage;
      var _this$state6 = this.state,
          contractSkuDetails = _this$state6.contractSkuDetails,
          merchantId = _this$state6.merchantId;
      var skus = Object.keys(contractSkuDetails);
      var endDate = this.getEndDate();
      var effectiveEndDate = endDate && endDate.format('YYYY-MM-DD');
      var effectiveStartDate = this.getStartDate().format('YYYY-MM-DD');
      var name = this.getContractName();
      this.setState({
        contractCreating: true
      });
      (0, _services.createListPriceContractTerm)(productFulfiller.id, merchantId, skus, name, effectiveStartDate, effectiveEndDate, skuFamily, onGetAccessToken, isProduction).then(function (res) {
        contractCreationCallback({
          contract: res,
          allSkus: skus,
          skusAddedToContract: skus,
          status: 'CREATED'
        });

        _this3.setState({
          contractCreating: false,
          contractCreated: true,
          newlyCreatedTermId: res.termId,
          newlyCreatedTermRevisionId: 1
        });
      }).catch(function (e) {
        contractCreationCallback({
          allSkus: skus,
          skusAddedToContract: [],
          status: 'ERROR',
          error: e
        });

        _this3.setState({
          contractCreating: false,
          contractCreated: false
        });

        var validationError = (0, _get.default)(e, 'response.extensions.innerDetails.validationErrors[0]');
        var errorMsg = validationError ? "".concat(validationError.message, " ").concat(validationError.value) : formatMessage(_listPriceInitiatorMessages.generalModalMessages.defaultErrorCreationMessage);

        _this3.handleError(errorMsg);
      });
    }
  }, {
    key: "renderTermButtonText",
    value: function renderTermButtonText() {
      var _this$state7 = this.state,
          contractCreated = _this$state7.contractCreated,
          contractCreating = _this$state7.contractCreating;
      var formatMessage = this.props.intl.formatMessage;

      if (contractCreating) {
        return _react.default.createElement("span", null, ' ', formatMessage(_listPriceInitiatorMessages.generalModalMessages.termButtonCreatingStatus), ' ', _react.default.createElement("i", {
          className: "fa fa-spinner fa-spin fa-fw"
        }), ' ');
      } else if (contractCreated) {
        return formatMessage(_listPriceInitiatorMessages.generalModalMessages.termButtonCreatedStatus);
      }

      return formatMessage(_listPriceInitiatorMessages.generalModalMessages.termButtonDefaultText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          allowedMerchants = _this$props3.allowedMerchants,
          isProduction = _this$props3.isProduction,
          onGetAccessToken = _this$props3.onGetAccessToken,
          productFulfiller = _this$props3.productFulfiller,
          skus = _this$props3.skus,
          show = _this$props3.show,
          _this$props3$intl = _this$props3.intl,
          formatMessage = _this$props3$intl.formatMessage,
          locale = _this$props3$intl.locale;
      var _this$state8 = this.state,
          contractCreated = _this$state8.contractCreated,
          contractCreating = _this$state8.contractCreating,
          contractSkuDetails = _this$state8.contractSkuDetails,
          newContractName = _this$state8.newContractName,
          createOption = _this$state8.createOption,
          duplicateSkuDetails = _this$state8.duplicateSkuDetails,
          selectedEndDate = _this$state8.selectedEndDate,
          lastAction = _this$state8.lastAction,
          listPrices = _this$state8.listPrices,
          selectedListPriceContract = _this$state8.selectedListPriceContract,
          listPriceContractsStatus = _this$state8.listPriceContractsStatus,
          skuDetailsStatus = _this$state8.skuDetailsStatus,
          skuDescriptions = _this$state8.skuDescriptions,
          errorInfo = _this$state8.errorInfo,
          hasError = _this$state8.hasError,
          merchantId = _this$state8.merchantId,
          merchantName = _this$state8.merchantName,
          newlyCreatedTermId = _this$state8.newlyCreatedTermId,
          newlyCreatedTermRevisionId = _this$state8.newlyCreatedTermRevisionId,
          noEndDateChecked = _this$state8.noEndDateChecked,
          skusOnContract = _this$state8.skusOnContract,
          step = _this$state8.step;

      if (!show) {
        return null;
      }

      var CONTRACT_MANAGER_URL = isProduction ? _constants.CONTRACT_MANAGER_PRD : _constants.CONTRACT_MANAGER_NONPRD;
      var termButtonText = this.renderTermButtonText();
      var display;

      switch (step) {
        case CHOOSE_MERCHANT_STEP:
          display = {
            body: _react.default.createElement(_ListPriceInitiatorMerchantSelectStep.default, {
              allowedMerchants: allowedMerchants,
              locale: locale,
              merchantId: merchantId,
              onMerchantIdChange: this.onMerchantIdChange
            }),
            footer: _react.default.createElement("span", null, _react.default.createElement("button", {
              className: "btn btn-default",
              onClick: this.closeModal
            }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.closeButtonText)), _react.default.createElement("button", {
              className: "btn btn-primary",
              disabled: !merchantId,
              onClick: this.nextStep
            }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.nextButtonText)))
          };
          break;

        case CREATE_OPTION_STEP:
          display = {
            body: _react.default.createElement(_ListPriceInitiatorCreateOptionStep.default, {
              createOption: createOption,
              fulfillerName: productFulfiller.name,
              handleError: this.handleError,
              isProduction: isProduction,
              locale: locale,
              lastAction: lastAction,
              listPrices: listPrices,
              merchantId: merchantId,
              nextStep: this.nextStep,
              onGetAccessToken: onGetAccessToken,
              onSelectCreateOption: this.onSelectedCreateOption,
              prevStep: this.prevStep,
              productFulfiller: productFulfiller,
              setAvailableListPriceContracts: this.setAvailableListPriceContracts,
              setListPriceContractsStatus: this.setListPriceContractsStatus,
              status: listPriceContractsStatus
            }),
            footer: _react.default.createElement("span", null, _react.default.createElement("span", {
              className: backButtonStyle
            }, _react.default.createElement("button", {
              className: "btn btn-default",
              disabled: hasError,
              onClick: this.prevStep
            }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.backButtonText))), _react.default.createElement("button", {
              className: "btn btn-default",
              onClick: this.closeModal
            }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.closeButtonText)), _react.default.createElement("button", {
              className: "btn btn-primary",
              disabled: !createOption || hasError,
              onClick: this.nextStep
            }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.nextButtonText)))
          };
          break;

        case CREATE_STEP:
          {
            var disable = createOption === NEW && (!newContractName || !selectedEndDate && !noEndDateChecked) || createOption === EXISTING && !selectedListPriceContract || hasError;
            display = {
              body: _react.default.createElement(_ListPriceCreateStep.default, {
                createOption: createOption,
                isProduction: isProduction,
                locale: locale,
                listPrices: listPrices,
                newContractName: newContractName,
                onChangeNewContractName: this.onChangeNewContractName,
                onSelectListPriceContract: this.onSelectListPriceContract,
                productFulfiller: productFulfiller,
                selectedListPriceContract: selectedListPriceContract,
                skus: skusOnContract
              }),
              footer: _react.default.createElement("span", null, _react.default.createElement("span", {
                className: backButtonStyle
              }, _react.default.createElement("button", {
                className: "btn btn-default",
                disabled: hasError,
                onClick: this.prevStep
              }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.backButtonText))), _react.default.createElement("button", {
                className: "btn btn-default",
                onClick: this.closeModal
              }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.closeButtonText)), _react.default.createElement("button", {
                className: "btn btn-primary",
                disabled: disable,
                onClick: this.nextStep
              }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.nextButtonText)))
            };
            break;
          }

        default:
          {
            var contractName = this.getContractName();
            var startDate = this.getStartDate();
            var endDate = this.getEndDate();
            var modifiers = this.getModifiers();
            display = {
              body: _react.default.createElement(_ListPriceInitiatorConfirmStep.default, {
                contractName: contractName,
                contractSkuDetails: contractSkuDetails,
                createOption: createOption,
                duplicateSkuDetails: duplicateSkuDetails,
                endDate: endDate,
                handleError: this.handleError,
                locale: locale,
                isProduction: isProduction,
                merchantId: merchantId,
                merchantName: merchantName,
                modifiers: modifiers,
                noEndDateChecked: noEndDateChecked,
                onGetAccessToken: onGetAccessToken,
                onError: this.setError,
                productFulfiller: productFulfiller,
                setDuplicateSkuDetails: this.setDuplicateSkuDetails,
                setContractSkuDetails: this.setContractSkuDetails,
                setSkuDetailsStatus: this.setSkuDetailsStatus,
                skuDescriptions: skuDescriptions,
                skus: skus,
                skusOnContract: skusOnContract,
                startDate: startDate,
                status: skuDetailsStatus
              }),
              footer: _react.default.createElement("span", null, _react.default.createElement("span", {
                className: backButtonStyle
              }, _react.default.createElement("button", {
                className: "btn btn-default",
                disabled: contractCreating || contractCreated || hasError,
                onClick: this.prevStep
              }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.backButtonText))), _react.default.createElement("button", {
                className: "btn btn-default",
                onClick: this.closeModal
              }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.closeButtonText)), _react.default.createElement("button", {
                className: "btn btn-primary",
                disabled: contractCreating || contractCreated || hasError,
                onClick: this.addSkusToContract
              }, termButtonText), contractCreated ? _react.default.createElement("div", {
                style: {
                  marginTop: '15px'
                }
              }, _react.default.createElement("a", {
                href: "".concat(CONTRACT_MANAGER_URL, "/").concat(newlyCreatedTermId, "/").concat(newlyCreatedTermRevisionId),
                target: "_blank",
                rel: "noopener noreferrer"
              }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.viewPendingContractText))) : null)
            };
          }
      }

      var errorSnackBar = hasError ? _react.default.createElement("div", {
        className: "alert alert-dismissible alert-danger"
      }, _react.default.createElement("p", null, _react.default.createElement("strong", null, _react.default.createElement("i", null, errorInfo))), _react.default.createElement("p", null, formatMessage(_listPriceInitiatorMessages.generalModalMessages.pleaseContactText), ' ', _react.default.createElement("a", {
        href: "mailto:".concat(_constants.FFS_EMAIL_ADDRESS, "?subject=Buy%20Button%20Error&body=").concat(errorInfo)
      }, formatMessage(_listPriceInitiatorMessages.generalModalMessages.financialFlowsSupportText)), ' ', formatMessage(_listPriceInitiatorMessages.generalModalMessages.forAssistanceText))) : null;
      var _display = display,
          body = _display.body,
          footer = _display.footer;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactComponents.Modal, {
        show: show,
        title: formatMessage(_listPriceInitiatorMessages.generalModalMessages.title),
        closeButton: true,
        onRequestHide: this.closeModal,
        closeOnOutsideClick: false,
        bsStyle: hasError ? 'warning' : 'info',
        className: "step".concat(step),
        footer: footer
      }, errorSnackBar, body));
    }
  }]);
  return ListPriceInitiatorWizardModal;
}(_react.default.Component);

ListPriceInitiatorWizardModal.defaultProps = {
  isProduction: false
};

var _default = (0, _reactIntl.injectIntl)(ListPriceInitiatorWizardModal);

exports.default = _default;